import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue.ts';
import { useDealInsightsContext } from '../../../../../context/DealInsightsContext.tsx';

export const useDeliveryByDomainBundleData = () => {
  const { dealInsights } = useDealInsightsContext();
  const { data, chartsLoadingState } = dealInsights;

  const transformedData =
    data?.delivery_by_domain_bundle.objects.map(item => {
      const vcrPercentage = item.vcr !== null && item.vcr !== undefined ? item.vcr * 100 : null;
      const sovPercentage = item.sov !== null ? item.sov * 100 : null;
      const ctrPercentage = item.ctr !== null ? item.ctr * 100 : null;
      const viewabilityPercentage =
        item.viewability !== null && item.viewability !== undefined ? item.viewability * 100 : null;

      return {
        // Raw values for coloring/visualization
        domain_bundle: item.domain_bundle,
        mobileappname: item.app_name,
        spend_raw: item.spend,
        sov_raw: item.sov,
        ecpm_raw: item.ecpm,
        vcr_raw: item.vcr ?? null,
        ctr_raw: item.ctr,
        viewability_raw: item.viewability ?? null,
        impressions_raw: item.impressions,
        // Formatted values for display
        ecpm: abbreviateNumericValue(item.ecpm, { allowZero: true, nullValue: 'N/A' }),
        sov: abbreviateNumericValue(sovPercentage, { allowZero: true, nullValue: 'N/A' }),
        spend: abbreviateNumericValue(item.spend, { allowZero: true, nullValue: 'N/A' }),
        vcr: abbreviateNumericValue(vcrPercentage, { allowZero: true, nullValue: 'N/A' }),
        ctr: abbreviateNumericValue(ctrPercentage, { allowZero: true, nullValue: 'N/A' }),
        viewability: abbreviateNumericValue(viewabilityPercentage, { allowZero: true, nullValue: 'N/A' }),
        impressions: abbreviateNumericValue(item.impressions, { allowZero: true, nullValue: 'N/A' }),
      };
    }) ?? [];

  return {
    data: transformedData,
    isLoading: !!chartsLoadingState.delivery_by_domain_bundle,
  };
};
